import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import loaderMixin from '@/mixins/loader';
import socialLevelMixin from '@/mixins/socialLevel';
import userDetailsMixin from '@/mixins/userDetails';
import { isMarketSingle } from '@/utils/helpers';

export default {
  mixins: [loaderMixin, socialLevelMixin, userDetailsMixin],
  props: {
    widget: Object,
  },
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
  },
  data() {
    return {
      swiperModules: [Autoplay],
      swiperOptions: {
        loop: true,
        autoplay: { enabled: true, delay: 5000 },
        slidesPerGroup: 2,
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerGroup: 1,
            slidesPerView: 1,
            slidesPerColumn: 2,
          },
        },
      },
    };
  },
  computed: {
    obj() {
      return this.widget ? this.widget : {};
    },
    traderCount() {
      return this.widget ? this.widget.activeTraderCount.toLocaleString('en-US') : '';
    },
    traders() {
      return this.obj.traders;
    },
  },
  watch: {
    widget(val) {
      if (val) {
        this.loaderRemove();
      }
    },
  },
  methods: {
    traderLevelDisplay(item) {
      const level = this.getLevelByPredictions(item.profitablePredictions);
      return `Level ${level.num} (${level.text})`;
    },
    priceClassModifiers() {
      return {
        'market-currently-predicting__price': true,
        // 'market-currently-predicting__price--multiple': !this.isMarketSingle(market),
        // 'market-currently-predicting__price--single': this.isMarketSingle(market),
      };
    },
    isMarketSingle(market) {
      return isMarketSingle(market);
    },
    boughtSold(type) {
      return type < 2 ? 'Bought' : 'Sold';
    },
    yesNo(type) {
      return type % 2 === 0 ? 'No' : 'Yes';
    },
    classModifier(type) {
      return {
        'market-currently-predicting__type': true,
        'market-currently-predicting__type--no': type % 2 === 0,
      };
    },
    onClick(pred) {
      if (pred.marketId) {
        this.$router.push({
          name: 'market-details',
          params: { marketId: pred.marketId, marketUrl: pred.marketUrl },
        });
      }
    },
  },
  mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  },
};
